import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Grid } from "antd";

import { useTrackVisibility } from "react-intersection-observer-hook";
import { useState, useEffect } from "react";
const { useBreakpoint } = Grid;

export function AircraftTypeHeroSection({ background = {}, typeName }) {
	const screens = useBreakpoint();
	const [ref, { isVisible }] = useTrackVisibility();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	return (
		<div style={{ width: "100%", position: "relative" }} ref={ref}>
			<RAImage url={background?.url} width="100%" height="100vh" />
			<Overlay />
			<WrapperContent>
				{screens?.md ? (
					<TextContainer className={`${visible && "animate__animated animate__fadeInDown"}`}>
						<RATypography variant="h1" color="#fff" style={{ display: "inline" }} classname="heading">
							{typeName}
						</RATypography>
					</TextContainer>
				) : (
					<TextContainer>
						<RATypography variant="h3" color="#fff" style={{ display: "inline" }} classname="heading">
							{typeName}
						</RATypography>
					</TextContainer>
				)}
			</WrapperContent>
		</div>
	);
}

const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
`;

const TextContainer = styled.div`
	text-align: center;
	background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
`;
const WrapperContent = styled.div`
	position: absolute;
	top: 25%;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;
